import { useState, useEffect } from "react";
import Para from "@/atoms/text/Para";
import Badge from "@/atoms/Badge";
import { ChevronArrowIcon } from "@/atoms/Icons";
import PlansCard from "@/molecules/PlansCard";
import { isMobileScreen } from "@/utils/functions";

const PlansList = ({
  plansData,
  showLargerPlansHandler,
  isLargerPlansVisible,
}) => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <>
      <ul
        className={`fx fx--c fx--r-d fx--fe fx--ch-d mb-7-d mb-5 ${
          isMobile ? "fx-v" : ""
        }`}
      >
        {plansData.map((plans, idx) => {
          return (
            <li
              className={`plan-list w-100 ps-r ${
                idx === plansData.length - 1 ? "" : "mr-7-d mb-7 mb-reset-d"
              } ${isMobile ? `fx--order-${plans.cardOrderInMobile}` : ""}`}
              key={idx}
            >
              {plans.isMostPopularValue && (
                <Badge className="align-topRight">Most popular</Badge>
              )}
              <PlansCard
                cardTitle={plans.cardTitle}
                minsPlusChat={plans.minsPlusChat}
                price={plans.price}
                setUpFee={plans.setUpFree}
                additionalMins={plans.additionalMins}
                features={plans.features}
                btnVariant={plans?.btnVariant}
                planId={plans.planid}
                isMostPopularValue={plans.isMostPopularValue}
                isBestValue={plans.isBestValue}
              />
              <style jsx>{`
                .plan-list {
                  max-width: 360px;
                  min-height: 620px;
                }
              `}</style>
            </li>
          );
        })}
      </ul>
      <div
        className={`fx fx--c fx-v fx--cv-d fx--ch-d mt-7 ta-center ${
          isLargerPlansVisible ? "is-open" : ""
        }`}
      >
        <Para
          color="grey"
          desktopSize="sm"
          mobileSize="sm"
          className="mb-7 w-40-d"
        >
          No charge for the first 30 interactions under 30 seconds per billing
          cycle. All interactions are billed per-minute and rounded up to the
          nearest minute.
        </Para>
        {showLargerPlansHandler ? (
          <button
            className="bold large-plans text text--lg-d text--md"
            onClick={showLargerPlansHandler}
          >
            <span className="mr-1 tc-blue">
              {isLargerPlansVisible ? "Hide larger plans" : "View larger plans"}
            </span>
            <ChevronArrowIcon
              className="accordion-arrow"
              width="12"
              height="12"
              color="#3270d8"
            />
            <style>{`
              .accordion-arrow {
                position: initial;
              }
          `}</style>
          </button>
        ) : (
          <a href="/plans" className="btn--link btn--link-lg bold">
            See more plans
          </a>
        )}
      </div>
    </>
  );
};

export default PlansList;
